import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import rightarrow from "../../../../../assets/images/rightarrow.svg";
import { useInView } from "react-intersection-observer";
function ProjectCard({ item, hoveredId, handleHover, isLargeScreen }) {
    const { ref, inView, entry } = useInView({
        /* Set trigger once to true if you only want it to trigger once */
        triggerOnce: false,
        threshold: 0.9, // Adjust this value between 0 and 1 to fine-tune when the callback should trigger
    });
    useEffect(() => {
        if (inView) {
            console.log("H2 is in the middle of the screen");
        }
    }, [inView]);
    const imageOpacityOnLarge =
        hoveredId === item.id ? "opacity-100" : "opacity-30";
    const imageOpacityOnMobile = inView ? "opacity-100" : "opacity-30";
    return (
        <Link to={`/products/${item.linkRoute}`}>
            <div
                key={item.id}
                className=" mx-auto  flex h-screen lg:h-[325px] w-[100%]  "
                ref={ref}
            >
                <div
                    ref={ref}
                    className={`flex-col watch  flex lg:flex-row z-20 py-4 md:py-14 relative justify-center  px-10 md:px-24 b  gap-10  ${
                        hoveredId === item.id ? " duration-300 ease-in-out" : ""
                    } w-full`}
                    onMouseEnter={() => handleHover(item)}
                    onMouseLeave={() => handleHover(null)}
                    onClick={() => handleHover(item)}
                >
                    {" "}
                    <img
                        id={`parallax-container-${item.id}`}
                        data-depth="0.3"
                        src={!isLargeScreen ? item.imageMobile : item.image}
                        className={`absolute duration-700 ease-in-out top-0 left-0 w-full h-full object-cover z-[-1] ${
                            isLargeScreen
                                ? `${imageOpacityOnLarge}`
                                : `${imageOpacityOnMobile}`
                        }`}
                        alt=""
                    />
                    <div className="w-full lg:w-1/3  md:pb-0   ">
                        <p className="text-white ">0{item.id}</p>
                    </div>
                    {/* <div className="h-full  justify-center lg:justify-between flex flex-col lg:flex-row bg-red-200"> */}
                    <div className="text-left w-full lg:w-1/3  flex flex-col  ">
                        <h3 className="mb-2 w-full lg:w-[80%] ">{item.name}</h3>{" "}
                        <h3 className="mb-3 text-[12px]  leading-[27px] h19 tracking-[1px] sm:text-[14px]">
                            {item.layer}
                        </h3>
                        <h6
                            className={`flex lg:w-full sm:w-1/2  w-[87%] text-[14px] leading-[21px]  h7 ${
                                item.id === 5 && "xl:w-[93%]"
                            }  ${
                                item.id === 3 || item.id === 2
                                    ? "xl:text-[14px] "
                                    : "xl:text-[15px]"
                            }  xl:leading-[25px] 2xl:text-[18px] 2xl:w-[70%] h7`}
                        >
                            {item.desc}
                        </h6>
                    </div>
                    <div className="mr-10 flex  items-start justify-start  md:pb-0 gap-6 w-full lg:w-1/3   mb-10">
                        <div className="flex flex-row gap-6  justify-between md:justify-end w-full align-middle items-start md:items-end  ">
                            <h7 className="h16">View Product</h7>

               
                                <img className="" src={rightarrow} alt="" />
   
                        </div>
                    </div>
                </div>
                {/* </div> */}
            </div>
        </Link>
    );
}

export default ProjectCard;
